import { IconButton, makeStyles, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Toolbar, Typography } from '@material-ui/core';
import {AddCircle, Edit, Delete, VisibilityOff, Visibility, Fingerprint} from '@material-ui/icons';
import React, {useEffect, useRef, useState} from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { groupRepository } from '../../../Domain/Repositories/GroupRepository';
import ErrorCardController from "../../UiComponents/ErrorCardController";
import Loading from "../../UiComponents/Loading";
import ScoreCard from "../../../Domain/Models/ScoreCard";
import {cubeRepository} from "../../../Domain/Repositories/CubeRepository";
import PlayerPairContent from "../PlayerPairs/PlayerPairContent";
import PlayerPair from "../../../Domain/Models/PlayerPair";
import ScoreCardModal from "./ScoreCardModal";

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
  },
  title: {
    flexGrow: 1
  },
  clickableCell: {
    cursor: 'pointer',
  },
}));


interface ScoreCardContentParams
{
  playerPairId: string;
}

export default function ScoreCardContent()
{
  const classes = useStyles();
  const history = useHistory();

  const errorCardControllerRef = useRef<ErrorCardController>(null);
  const {playerPairId} = useParams<ScoreCardContentParams>();

  const [playerPair, setPlayerPair] = useState<PlayerPair>();
  const [loading, setLoading] = useState(false);
  const [idVisible, setIdVisible] = useState(false);
  const [scoreCardDialogOpen, setScoreCardDialogOpen] = useState(false);
  const [scoreCardToEdit, setScoreCardToEdit] = useState<ScoreCard>();

  const forceReload = () =>
  {
    setLoading(true);
    groupRepository.load()
      .then(() => cubeRepository.load())
      .then(() =>
      {
        const foundPair = groupRepository.getPlayerPairById(playerPairId);
        setPlayerPair(foundPair);

        if (foundPair === undefined)
        {
          errorCardControllerRef.current?.addErrorMessage("Player pair not found");
        }
        setLoading(false);
      })
      .catch((e: Error) =>
      {
        setLoading(false);
        errorCardControllerRef.current?.addErrorMessage(e.message);
      });
  }
  
  const handleEditScoreCardClicked = (scoreCard: ScoreCard) =>
  {
    setScoreCardToEdit(scoreCard);
    setScoreCardDialogOpen(true);
  }

  const handleDialogClose = () =>
  {
    setScoreCardDialogOpen(false);
    setScoreCardToEdit(undefined);
    forceReload();
  };

  useEffect(() =>
  {
    forceReload();

  }, []);

  return (
    <>
      {playerPair !== undefined && scoreCardToEdit !== undefined && (
        <ScoreCardModal
          open={scoreCardDialogOpen}
          onClose={handleDialogClose}
          scoreCard={scoreCardToEdit}
          playerPair={playerPair}
        />
      )}
      
      <Loading isLoading={loading}>
        <ErrorCardController ref={errorCardControllerRef}/>

        <Paper className={classes.paper}>
          <Toolbar>
            <Typography className={classes.title} component="h2" variant="h6" color="primary" gutterBottom>
              {playerPair?.players.map(x => `${x.name}, `)}
            </Typography>
            <IconButton size="small" color="default" onClick={() => setIdVisible(!idVisible)}>
              { idVisible ? <VisibilityOff/> : <Visibility/> }
            </IconButton>
          </Toolbar>

          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  {idVisible && <TableCell>ID</TableCell>}
                  <TableCell>#</TableCell>
                  <TableCell>Cube</TableCell>
                  <TableCell>Completed</TableCell>
                  <TableCell>Lives Remaining</TableCell>
                  <TableCell>Simplify Used</TableCell>
                  <TableCell>Swap Used</TableCell>
                  <TableCell/>
                </TableRow>
              </TableHead>
              <TableBody>
                {playerPair?.scorecards
                  .sort((a, b) => +new Date(b.createdAt) - +new Date(a.createdAt))
                  .reverse()
                  .map((x, index) => (
                  <TableRow key={x.id} hover>
                    {idVisible && <TableCell scope="row">{x.id}</TableCell>}
                    <TableCell>
                      {(index + 1).toString()}
                    </TableCell>
                    <TableCell>
                      {x.cube.name}
                    </TableCell>
                    <TableCell>
                      {x.completed ? 'Yes' : 'No'}
                    </TableCell>
                    <TableCell>
                      {x.livesRemaining}
                    </TableCell>
                    <TableCell>
                      {x.simplifyUsed ? 'Yes' : 'No'}
                    </TableCell>
                    <TableCell>
                      {x.swapUsed ? 'Yes' : 'No'}
                    </TableCell>
                    <TableCell>
                      <IconButton size="small" color="default" onClick={() => handleEditScoreCardClicked(x)}>
                        <Edit/>
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>

        </Paper>
        
      </Loading>
    </>
  );
}